export default __webpack_public_path__ + "static/media/armor.681a20e7.png";